export const selectMyChatRole = (state, chatId, myUserId) => {
  const members = state.chat.membersByChat[chatId] || [];
  const me = members.find(m => String(m.user.id) === String(myUserId));
  return me?.role || null;
};

export const selectMyChatPermissions = (state, chatId, myUserId) => {
  const role = selectMyChatRole(state, chatId, myUserId);

  return {
    isOwner: role === "owner",
    isAdmin: role === "admin" || role === "owner",
    canEditChat: role === "admin" || role === "owner",
    canManageMembers: role === "admin" || role === "owner",
    canLeaveChat: role !== "owner", // owner only after transfer
  };
};
